import styled from "styled-components";

export const StyledLabel = styled.label`
  position: relative;
  padding-left: 30px;
  margin: 5px 0;
  cursor: pointer;
  font-weight: 400;
  color: #333;
  font-family: ${({ theme }) => theme.fontFamily};
`;

StyledLabel.displayName = "StyledLabel";

export const StyledIndicator = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 19px;
  width: 19px;
  border-radius: 4px;
  background: #fff;
  border: 2px solid #e7e7e7;
  transition: 0.1s ease-in-out;

  &:after {
    content: "\f00c ";
    font-family: FontAwesome;
    position: absolute;
    top: -4px;
    left: 0;
    color: #fff;
  }

  &:hover {
    border: 2px solid #f2008c;
  }
`;

StyledIndicator.displayName = "StyledIndicator";

export const StyledInput = styled.input`
  position: absolute;
  z-index: -1;
  opacity: 0;

  &:checked ~ ${StyledIndicator} {
    background: #f2008c;
    border: 2px solid #f2008c;

    &:after {
      display: block;
    }
  }
`;

StyledInput.displayName = "StyledInput";
